import { render } from "./FullDataView.vue?vue&type=template&id=0c041a8c&ts=true"
import script from "./FullDataView.vue?vue&type=script&lang=ts"
export * from "./FullDataView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__